export const BG_ENDPOINTS = {
    Endpoint: `${process.env["REACT_APP_BREAKGLASS_API"]}`,
    Resources: [
        "request/mine",
        "review/pending",
        "review/processed",
        "audit/requests",
        "request/create",
        "request/delete",
        "review/approve",
        "review/reject",
        "federate/console",
        "federate/cli",
    ],
};

export const AWS_ACCOUNTS = {
    "211125671970": "arup-ukimea-adp-data-backup-prod",
    "299512259480": "arup-ukimea-adp-prod",
    "992382511840": "arup-ukimea-adp-data-prod",
    "055094238296": "arup-global-dsa-notebook1-prod",
    "067406190111": "arup-ukimea-adp-preprod",
};

/**
 * Translates an AWS account ID to its friendly name
 * @param accountId - The AWS account ID to translate
 * @returns The friendly account name or the original account ID if not found
 */
export const translateAccountId = (accountId: string): string => {
    return AWS_ACCOUNTS[accountId as keyof typeof AWS_ACCOUNTS] || accountId;
};
